<accordion [isAnimated]="true">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-money-bill'></i> Devolver contrato {{loan.contractNumber}}
    </span>
    <div class="alert alert-success" role="alert" [hidden]="!loanForm.valid">
      <h4 class="alert-heading"><i class="fa fa-check mr-2" aria-hidden="true"></i>Contrato ya cancelado</h4>
      <p>¡Este contrato ya fue cancelado!</p>
      <hr>
      <div class="mb-0 d-flex justify-content-end">
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <!-- <button type="button" (click)="cancel()" [disabled]="validateCanceled()"
                  class="btn btn-sm btn-success"><i class="fa fa-times"></i>&nbsp;Cancelar</button> -->
        <button type="button" class="btn btn-lg btn-outline-primary mr-2" (click)="return()"
          [disabled]="loanForm.valid"><i class="fa fa-regular fa-file-lines"></i>&nbsp;Devolver Contrato</button>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label"><b>Saldo a favor del cliente</b></label>
      <div class="col-md-9">
        <input type="text" id="text-input" name="text-input" class="form-control" prefix="HNL " mask="separator.2"
          thousandSeparator="," readonly [(ngModel)]="balance">
      </div>
    </div>
    <!-- <div class="form-group row" [hidden]="loanForm.valid">
      <label class="col-md-3 col-form-label"><b>Cargos Administrativos</b></label>
      <div class="col-md-9">
        <input type="text" id="text-input" name="text-input" class="form-control" prefix="HNL " mask="separator.2"
          thousandSeparator="," [(ngModel)]="surcharge">
      </div>
    </div> -->

  </accordion-group>
  <accordion-group [isOpen]="true" *ngIf="showPayments()">
    <span accordion-heading>
      <i class='fa fa-money-bill'></i> Pago de Cargo Administrativo
    </span>
    <app-pos-payment-method [totalAmount]="getAmountofPayments()" [disablePaymentButton]="true"
      (doPayment)="getPayments($event)" [customerCode]="loan.customerCode"></app-pos-payment-method>
  </accordion-group>
</accordion>